// 省份或州级行政区划数据
export const provinceOrStateData = {
  Malaysia: [
    { value: "JOHOR", title: "JOHOR" },
    { value: "KEDAH", title: "KEDAH" },
    { value: "KELANTAN", title: "KELANTAN" },
    { value: "MELAKA", title: "MELAKA" },
    { value: "NEGERI SEMBILAN", title: "NEGERI SEMBILAN" },
    { value: "PAHANG", title: "PAHANG" },
    { value: "PERAK", title: "PERAK" },
    { value: "PERLIS", title: "PERLIS" },
    { value: "PULAU PINANG", title: "PULAU PINANG" },
    { value: "SABAH", title: "SABAH" },
    { value: "SARAWAK", title: "SARAWAK" },
    { value: "SELANGOR", title: "SELANGOR" },
    { value: "TERENGGANU", title: "TERENGGANU" },
    { value: "W.P. KUALA LUMPUR", title: "W.P. KUALA LUMPUR" },
    { value: "W.P. LABUAN", title: "W.P. LABUAN" },
    { value: "W.P. PUTRAJAYA", title: "W.P. PUTRAJAYA" },
  ],
};
